import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ModalBaseLayout from '../ModalBaseLayout';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {CloseIcon} from '../../SvgComponents/SvgComponents';
import defaultUser from '../../../assets/images/required/user.png';
import {getUserNameFromString, getRole} from '../../../services/common';

class ModalContactCard extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center modal-contact-card',
      closeButton: true,
      keyboard: true,
    });
  }

  render() {
    const {
      name, phoneNumber, role, username, photoUrl, company,
    } = this.props;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <button className="modal-close-btn" onClick={this.props.ActionModalHide}>
            <CloseIcon />
          </button>
          <div className="modal-content">
            <div className="user-avatar user-image">
              <img src={photoUrl || defaultUser} alt="" />
            </div>
            <div className="user-name">{getUserNameFromString(name, true)}</div>
            {role && <div className="user-role">{getRole(role)}</div>}
            <table className="user-info">
              <tbody>
              {company
              && (
                <tr className="user-info_row">
                  <td className="user-info_title">Компания</td>
                  <td className="user-info_descr">{company.fullName || company.shortName}</td>
                </tr>
              )}
              {phoneNumber
              && (
                <tr className="user-info_row">
                  <td className="user-info_title">Телефон</td>
                  <td className="user-info_descr">
                    <ul className="user-info_list">
                      <li className="user-info_item">{phoneNumber}</li>
                    </ul>
                  </td>
                </tr>
              )}
              {username
              && (
                <tr className="user-info_row">
                  <td className="user-info_title">Email</td>
                  <td className="user-info_descr">
                    <ul className="user-info_list">
                      <li className="user-info_item">
                        {username}
                      </li>
                    </ul>
                  </td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalContactCard.propTypes = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ModalContactCard);
